
import { AddMissionDialog } from "./AddMissionDialog";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useLanguage } from "@/contexts/LanguageContext";
import { useUserRoles } from "@/hooks/useUserRoles";
import { ClipboardList } from "lucide-react";

interface Team {
  id: string;
  name: string;
}

interface TeamMissionsHeaderProps {
  teams?: Team[];
  teamId?: string;
  onTeamChange: (teamId: string) => void;
  isAdmin: boolean;
  onAddMission: (title: string, description: string, category: string, attachmentUrl?: string, missionType?: string, startsAt?: string, expiresAt?: string) => Promise<void>;
}

export const TeamMissionsHeader = ({
  teams,
  teamId,
  onTeamChange,
  isAdmin,
  onAddMission,
}: TeamMissionsHeaderProps) => {
  const { language } = useLanguage();
  const { roles } = useUserRoles();
  const isClient = roles.includes('client');
  
  return (
    <div className="space-y-8">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <div className="space-y-2">
          <div className="flex items-center gap-2">
            <ClipboardList className="w-6 h-6 text-teal-500" />
            <h1 className="text-2xl font-semibold text-secondary-800">
              {language === "en" ? "Work Instructions" : "Οδηγίες Εργασίας"}
            </h1>
          </div>
          <p className="text-gray-500">
            {language === "en" 
              ? "View and manage team work instructions" 
              : "Εμφάνιση και διαχείριση οδηγιών εργασίας της ομάδας"}
          </p>
        </div>
        <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4 w-full md:w-auto">
          <Select value={teamId} onValueChange={onTeamChange}>
            <SelectTrigger className="w-full sm:w-[200px]">
              <SelectValue placeholder={language === "en" ? "Select Team" : "Επιλέξτε Ομάδα"} />
            </SelectTrigger>
            <SelectContent>
              {teams?.map((team) => (
                <SelectItem key={team.id} value={team.id}>
                  {team.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          {/* Allow both admins and clients to add missions when a team is selected */}
          {teamId && <AddMissionDialog onSubmit={onAddMission} disabled={!teamId} />}
        </div>
      </div>
    </div>
  );
};
